import React from 'react'
import ControlledRadioGroupInput from 'transfix-form/components/ControlledRadioGroupInput'
import { IMotorCarrierComplianceFlagsQuery } from '../graphql/MotorCarrierComplianceFlags'
import { useCarrierAddFlagModalFormContext } from './useCarrierAddFlagModalForm'

interface ICarrierAddFlagModalForm {
  flagData: IMotorCarrierComplianceFlagsQuery | undefined
}

export const CarrierAddFlagModalForm = ({ flagData }: ICarrierAddFlagModalForm) => {
  const { motorCarrierComplianceFlags } = flagData || {}
  const [firstFlag] = motorCarrierComplianceFlags || []
  const { complianceFlag } = firstFlag || {}
  const { name } = complianceFlag || {}
  const { control } = useCarrierAddFlagModalFormContext()

  const isCarrierFlagged = !!name

  const options = isCarrierFlagged
    ? [{ label: 'Remove Flag', id: 'removeFlag' }]
    : [
        {
          label: 'Probation',
          id: 'probation',
        },
        {
          label: 'Do Not Use',
          id: 'dnu',
        },
      ]

  return (
    <form data-test='CarrierAddFlagModalForm'>
      <ControlledRadioGroupInput name='flagName' control={control} defaultValue options={options} />
    </form>
  )
}
